import { Component, Vue, Mixins, Watch } from 'vue-property-decorator';
import { AllComponents } from '@/components/AllComponents';
import CommonView from '@/views/CommonView';
import BASEAPI from '@/util/BASEAPI';
import { AxiosErrorHandler, isAxiosError } from '@/util/AxiosErrorHandler';
import { ProductPrizeGroupCategoryEnum } from '@/generated/api';

@Component({
    components: AllComponents(),
})
export default class ProductDetails extends Mixins(CommonView) {
    kurukuru: boolean = false;
    public error: string = "";

    public product: BASEAPI.Product | null = null;
    public inSale: boolean = false;
    public now: number = 0;
    public startAt: number = 0;
    public endAt: number = 0;

    public normalPrizeGroupList: {
        productPrizeGroup: BASEAPI.ProductPrizeGroup,
        prizeList: {
            prize: BASEAPI.Prize,
            index: number
        }[]
    }[] = [];
    public normalPrizeList: {src: string, title: string}[] = [];
    public nVisible: boolean = false;
    public nIndex: number | null = null;
    public wChancePrizeGroup: BASEAPI.ProductPrizeGroup = BASEAPI.productPrizeGroup();
    public wChancePrizeList: {src: string, title: string}[] = [];
    public wVisible: boolean = false;
    public wIndex: number | null = null;
    public bonusPrizeGroup: BASEAPI.ProductPrizeGroup = BASEAPI.productPrizeGroup();
    public bonusPrizeList: {src: string, title: string}[] = [];
    public bVisible: boolean = false;
    public bIndex: number | null = null;


    public async created() {
        await this.init();

    }

    @Watch('$route')
    public async init() {
        this.kurukuru = true;
        this.normalPrizeGroupList = [];
        this.normalPrizeList = [];
        this.wChancePrizeGroup = BASEAPI.productPrizeGroup();;
        this.bonusPrizeGroup = BASEAPI.productPrizeGroup();;

        let directoryName = this.$route.params.directoryName;
        if(!directoryName){
            this.$router.push("/");
            return;
        }

        let state = this.$route.query.state ? <any>this.$route.query.state : undefined;

        let res = await BASEAPI.ProductController.getProductUsingGET(directoryName, state).catch(AxiosErrorHandler);
        if (isAxiosError(res)) {
            this.error = "" + res.data;
            this.$router.push("/");
            return;
        }

        this.product = res.data;
        let index = 0;
        this.product.productPrizeGroupList?.forEach(productPrizeGroup => {
            if(productPrizeGroup.category == ProductPrizeGroupCategoryEnum.Normal){
                let prizeList: {prize: BASEAPI.Prize, index: number}[] = [];

                productPrizeGroup.prizeList?.forEach(prize => {
                    this.normalPrizeList.push({src: prize.image, title: prize.title});
                    prizeList.push({prize, index});
                    index++;
                });
                
                this.normalPrizeGroupList.push({prizeList: prizeList, productPrizeGroup});
            }
            if(productPrizeGroup.category == ProductPrizeGroupCategoryEnum.WChance){
                this.wChancePrizeGroup = productPrizeGroup;
                productPrizeGroup.prizeList?.forEach(prize => {
                    this.wChancePrizeList.push({src: prize.image, title: prize.title});
                });
            }
            if(productPrizeGroup.category == ProductPrizeGroupCategoryEnum.Bonus){
                this.bonusPrizeGroup = productPrizeGroup;
                productPrizeGroup.prizeList?.forEach(prize => {
                    this.bonusPrizeList.push({src: prize.image, title: prize.title});
                });
            }
        });
        
        // 販売チェック
        this.inSale = true;
        this.now = new Date().getTime();
        this.startAt = new Date(this.product.saleStartedAt!).getTime();
        this.endAt = new Date(this.product.saleEndedAt!).getTime();

        if(this.product.inSale === false){
            this.inSale = false;
        }

        if(this.startAt > this.now){
            this.inSale = false;
        }

        if(this.endAt < this.now){
            this.inSale = false;
        }

        this.kurukuru = false;
    }

    showImg (index: number, type: string) {
        if(type == 'normal'){
            this.nIndex = index;
            this.nVisible = true;
        }
        if(type == 'wChance'){
            this.wIndex = index;
            this.wVisible = true;
        }
        if(type == 'bonus'){
            this.bIndex = index;
            this.bVisible = true;
        }
    }
    handleHide () {
        this.nVisible = false;
        this.wVisible = false;
        this.bVisible = false;
    }

    public async check(){
        // ログインしていない場合
        if (await this.isLoginRedirect(true) || !this.inSale) {
            return;
        } else {
            this.$router.push("/product/" + this.product!.directoryName + "/shopping");
        }
    }
}
